import React from "react";
import { useTranslation } from "react-i18next";
import { css } from "@emotion/css";
import Select from "react-select";
import Divider from "@mui/material/Divider";

const classes = {
    instruction: css`
        margin: 10px 0;
        font-weight: bold;
    `,
    select: css`
        margin-bottom: 10px;
        // z-index: 1000;
    `,
    divider: css`
        margin: 10px 0;
    `,
};

const SelectCountryPopulation = (props) => {
    const { countries, selectedCountryNumericCode, onSelectCountry } = props;

    const { t } = useTranslation();

    const value = props.countries.filter(({ value }) => value === selectedCountryNumericCode);
    // const singleCountry = props.countries.length === 1;

    // React.useEffect(() => {
    //     if (singleCountry && selectedCountryNumericCode !== countries[0].value) {
    //         onSelectCountry(countries[0].value);
    //     }
    // }, [onSelectCountry, singleCountry, selectedCountryNumericCode, countries]);

    return (
        <div>
            <div className={classes.instruction}>3a. {t("Select country")}</div>

            <Select
                placeholder={t("Select country")}
                options={countries}
                value={value}
                noOptionsMessage={() => "No countries available"}
                className={classes.select}
                onChange={({ value }) => {
                    onSelectCountry(value);
                }}
            />

            <Divider className={classes.divider} />
        </div>
    );
};

export default SelectCountryPopulation;
